<template>
  <div style="height: auto;width: auto;position: absolute;top: 12vh;right: 0;min-width: 500px;padding: 5px 10px;border:1px solid rgb(140, 140, 140)">
    <div>
      
      <h1 v-show="station.grid_type != 'grid3'" style="color: white">{{station.name}}
      <span style="float: right;cursor: pointer;" @click="closeWindow">x  </span></h1>
      <h1 v-show="station.grid_type == 'grid3'">3x3网格</h1>
      
      <!-- <el-button @click="drawChildGrid(1)" v-show="!station.large_grid_box">查看1*1网格</el-button> -->
      <!-- <el-button>查看0.5*0.5网格</el-button> -->
    </div>
    
    <!-- <div>网格列表: <span v-for="g in station.child_grids">{{g.name}}</span></div> -->
    <div class="field_height" v-show="station.pm25 || station.pm10">
      <div v-show="dataType == 'pm25'" class="tb_label">PM₂.₅:</div><div  v-show="dataType == 'pm25'" class="tb_value" :style="{background: pm25_color.bgcolor,color: pm25_color.fgcolor}">{{station.pm25 | data_filter}}</div>
      <div v-show="dataType == 'pm10'" class="tb_label">PM₁₀:</div><div v-show="dataType == 'pm10'" class="tb_value" :style="{background: pm10_color.bgcolor,color: pm10_color.fgcolor}">{{station.pm10 | data_filter}}</div>
    </div>
    <div class="field_height" v-show="station_data.wendu || station_data.shidu">
      <div class="tb_label">温度:</div><div class="tb_value">{{station_data.wendu}}</div>
      <div class="tb_label">湿度:</div><div class="tb_value">{{station_data.shidu}}</div>
    </div>

    <div class="field_height" v-show="station_data.wind_direction || station_data.wind_speed">
      <div class="tb_label">风速:</div><div class="tb_value">{{station_data.wind_speed}}</div>
      <div class="tb_label">风向:</div><div class="tb_value">{{station_data.wind_direction | getWindDirectionDesc}}</div>
    </div>
    
    <div class="field_height">
      <div class="tb_label">时间:</div><div class="tb_value" style="border:none">{{station.time*1000 | timest_to_str}}</div>
    </div>
    <div class="field_height">
      <div class="tb_label">经纬度:</div><div class="tb_value" style="border:none">{{Math.round(station.lng * 100000) / 100000}}, {{Math.round(station.lat * 100000)/ 100000}}</div>
    </div>
    <div>
      <!-- <img src="static/img/chart.jpg"> -->
    </div>
    <!-- <div style="height:180px" id="window_chart"></div> -->
    <table class="ui striped celled compact center aligned very inverted basic table ">
      <thead>
        <tr>
          <th>序号 </th>
          <th>区县 </th>
          <th>街镇 </th>
          <th>微站名称 </th>
          <th>{{type_name[dataType]}}</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(s,idx) in child_stations.slice((currentPageZ-1)*pageSize, currentPageZ*pageSize)"  style="cursor: pointer;">
          <td >{{pageSize*(currentPageZ-1) + idx + 1}}</td>
          <td :title="s.name2" >{{s.name2}}</td>
          <td :title="s.name3" >{{s.name3}}</td>
          <td :title="s.name" >{{s.name}}</td>
          <td>
            <div style="width: 80%;height:80%;text-align: center" >
              {{s.data[dataType]}}
            </div>
          </td>
        </tr>
      </tbody>
    </table>
    <el-pagination
      layout="prev, pager, next"
      :page-size="pageSize"
      :current-page.sync="currentPageZ"
      :total="child_stations.length">
    </el-pagination>
  </div>
</template>

<script>
import HighCharts from 'highcharts'
import {checkEnd} from '@/utils/util'
import {getSingleStationData,getPollutionLevel,getStationHistory,getStationAlarmHistory} from '@/api/api'
import {option_window,option_pie,option_pie2} from '@/options/option'
import {type_name} from '@/utils/common' 
import {timest_to_str,getWindDirectionDesc, data_filter} from '@/utils/filters'
export default{
  data(){
    return{
      type_name,
      currentPageZ:0,
      pageSize:6,
      station_data:{},
      chart:null,
      child_stations:[]
    }
  },
  props:[
    'station',
    'dataType',
    'timeType',
    'stations'
  ],
  watch:{
    station(){
      console.log(this.station)
      this.getDetail()
    }
  },
  mounted(){
    this.getDetail()
  },
  beforeRouteLeave(){
    console.log('leave')
  },
  computed:{
    pm25_color(){
      if (this.station.pm25){
        return this.getPMInfo(this.station.pm25, 'pm25')  
      }else{
        return ''
      }
    },
    pm10_color(){
      if (this.station.pm10){
        return this.getPMInfo(this.station.pm10, 'pm10')  
      }else{
        return ''
      }
    }
  },
  filters:{
    getWindDirectionDesc,
    timest_to_str,
    data_filter
  },
  methods:{
    getPMInfo,
    closeWindow() {
      this.$emit('closeWindow')
    },
    drawChildGrid(r) {
      if (!this.station.large_grid_box){
        this.$emit('drawChildGrid', {r: r, grid :this.station})
      }
    },
    getDetail(){
      let child_stations = []
      if (this.station.grid_type == 'grid3'){
        let child_grids = this.station.child_grids
        for(let g of child_grids){
          if (!g.childs){
            continue
          }
          let childs = g.childs.split(',')
          for(let i of childs){
            child_stations.push(this.$_.find(this.stations,function(x){return i == x.station_id}))
          }
        }
      }else{
        if (this.station.childs) {
          var childs = this.station.childs.split(',')
          for(let i of childs){
            child_stations.push(this.$_.find(this.stations,function(x){return i == x.station_id}))
          }
        }
        
      }
      this.child_stations = child_stations
    },
    draw_window_chart(timep=null){
      let data_time = this.station.data.time
      let start = data_time - 1*3600
      let end = checkEnd(data_time + 1*3600)
      let time_type = '1m'

      if (timep == 'hour'){
        time_type = '1h'
        start = data_time - 24*3600 * 2
        end = checkEnd(data_time + 24*3600 * 2)
      }
      if (timep == 'day'){
        time_type = '1d'
        start = data_time - 24*3600 * 10
        end = checkEnd(data_time + 24*3600 * 10)
      }
      let station_id = this.station.station_id
      getStationHistory(time_type,station_id,start,end).then(function(resp){
        getStationAlarmHistory(station_id,start,end).then(function(x){
          let alarms = x.data
          let data = resp.data.datas
          let pm25_data=[]
          let pm10_data=[]
          for(let i of data){
            pm25_data.push([i[0]*1000,Math.round(i[1])])
            pm10_data.push([i[0]*1000,Math.round(i[2])])
          }
          let series = [{name:'PM₂.₅',data:pm25_data},{name:'PM₁₀',data:pm10_data}]
          if (alarms.length > 0){
            for(let a of alarms){
              let alarm_type=a.type.slice(0,4)
              let alarm_start = self.$moment(a.start_data_time).unix()
              let alarm_end = a.end_data_time
              if (alarm_end){
                alarm_end = self.$moment(a.end_data_time).unix()
              }else{
                alarm_end = self.$moment().unix()
              }
              let filter_data = pm25_data
              if (alarm_type == 'pm10'){
                filter_data = pm10_data
              }
              let alarm_series_data = _.filter(filter_data,function(x){return x[0]/1000 >= alarm_start && x[0]/1000 <= alarm_end})
              series.push({name:a.name, data: alarm_series_data, color:'red'})
            }
          }
          option_window.series = series
          let chart = HighCharts.chart('window_chart',option_window);
          chart.xAxis[0].removePlotLine('plot-line-1');
          chart.xAxis[0].addPlotLine({           //在x轴上增加
            value:data_time*1000,                           //在值为2的地方
            width:1,                           //标示线的宽度为2px
            color: 'white',                      //标示线的颜色
            id: 'plot-line-1'                  //标示线的id，在删除该标示线的时候需要该id标示
          });
        })
        
      })
    }
  }
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/GridDialog.vue